// Undine — theme motion + cart interactions.
(() => {
  // ─── Nav: add .scrolled class once you've scrolled past the hero edge ──
  // (No auto-hide — nav stays pinned at top during all scroll directions.)
  const nav = document.getElementById('nav');
  if (nav) {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        nav.classList.toggle('scrolled', window.scrollY > 60);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ─── Desktop Shop dropdown — click-toggle + outside-click close ─────
  const megaWrap = document.getElementById('has-mega');
  const megaTrigger = document.getElementById('mega-trigger');
  const megaPanel = document.getElementById('mega-panel');
  if (megaWrap && megaTrigger && megaPanel) {
    const closeMega = () => {
      megaWrap.classList.remove('open');
      megaTrigger.setAttribute('aria-expanded', 'false');
    };
    megaTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const open = megaWrap.classList.toggle('open');
      megaTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (megaWrap.classList.contains('open') && !megaWrap.contains(e.target)) closeMega();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && megaWrap.classList.contains('open')) {
        closeMega();
        megaTrigger.focus();
      }
    });
    // When user hovers, ensure aria-expanded reflects visible state
    megaWrap.addEventListener('mouseenter', () => megaTrigger.setAttribute('aria-expanded', 'true'));
    megaWrap.addEventListener('mouseleave', () => {
      if (!megaWrap.classList.contains('open')) megaTrigger.setAttribute('aria-expanded', 'false');
    });
  }

  // ─── Mobile drawer + accordion ──────────────────────────────────────
  const burger = document.getElementById('nav-burger');
  const drawer = document.getElementById('nav-drawer');
  const scrim  = document.getElementById('drawer-scrim');
  const drawerClose = document.getElementById('drawer-close');
  const shopToggle = document.getElementById('drawer-shop-toggle');
  const shopPanel  = document.getElementById('drawer-shop-panel');

  function openDrawer() {
    if (!drawer || !scrim) return;
    drawer.hidden = false;
    scrim.hidden = false;
    // next frame so CSS transitions engage
    requestAnimationFrame(() => {
      drawer.classList.add('open');
      scrim.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
    });
  }
  function closeDrawer() {
    if (!drawer || !scrim) return;
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    // hide after transition ends
    setTimeout(() => {
      if (!drawer.classList.contains('open')) {
        drawer.hidden = true;
        scrim.hidden = true;
      }
    }, 420);
  }
  if (burger) burger.addEventListener('click', () => {
    if (drawer && drawer.classList.contains('open')) closeDrawer(); else openDrawer();
  });
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
  });
  if (shopToggle && shopPanel) {
    shopToggle.addEventListener('click', () => {
      const open = shopToggle.getAttribute('aria-expanded') === 'true';
      shopToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) {
        shopPanel.removeAttribute('data-open');
        setTimeout(() => { shopPanel.hidden = true; }, 420);
      } else {
        shopPanel.hidden = false;
        requestAnimationFrame(() => shopPanel.setAttribute('data-open', 'true'));
      }
    });
  }

  // ─── Hero sparkles ──────────────────────────────────────────────────
  const sparkContainer = document.getElementById('sparkles');
  if (sparkContainer) {
    for (let i = 0; i < 40; i++) {
      const el = document.createElement('div');
      el.className = 'spark';
      el.style.left = (Math.random() * 100) + '%';
      el.style.top  = (Math.random() * 90)  + '%';
      const size = 2 + Math.random() * 4;
      el.style.width = size + 'px';
      el.style.height = size + 'px';
      el.style.animationDuration = (2.4 + Math.random() * 3) + 's';
      el.style.animationDelay    = (-Math.random() * 4)       + 's';
      sparkContainer.appendChild(el);
    }
  }

  // ─── Reveal-on-scroll ──────────────────────────────────────────────
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // ─── Hero parallax (disabled on small screens + reduced-motion) ────
  const hero = document.getElementById('hero');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (hero && window.matchMedia('(min-width: 901px)').matches && !prefersReducedMotion) {
    const inner = hero.querySelector('.hero-inner');
    const rays  = hero.querySelector('.rays');
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = Math.min(window.scrollY, 900);
        if (inner) inner.style.transform = `translateY(${y * 0.08}px)`;
        if (rays)  rays.style.transform  = `translateY(${y * 0.18}px)`;
        ticking = false;
      });
    }, { passive: true });
  }

  // ─── Cart count update helper ───────────────────────────────────────
  const updateCartCount = async () => {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const cart = await r.json();
      document.querySelectorAll('[aria-label^="Bag"]').forEach((btn) => {
        const existing = btn.querySelector('.bag-count');
        if (cart.item_count > 0) {
          if (existing) {
            existing.textContent = cart.item_count;
          } else {
            const span = document.createElement('span');
            span.className = 'bag-count';
            span.textContent = cart.item_count;
            btn.appendChild(span);
          }
        } else if (existing) {
          existing.remove();
        }
      });
    } catch (_) { /* ignore */ }
  };

  // ─── Quick-add from product cards ──────────────────────────────────
  // The <a class="product-card"> wraps the whole card, so a click on
  // .quickadd would navigate to the PDP. We intercept on .quickadd only,
  // stop propagation + preventDefault, then fire /cart/add.js.
  document.addEventListener('click', async (e) => {
    const quick = e.target.closest('.quickadd');
    if (!quick) return;
    const card = quick.closest('.product-card[data-variant-id]');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = card.dataset.variantId;
    if (!variantId || variantId === '') return;

    const originalText = quick.textContent;
    quick.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error(`Add failed (${res.status})`);
      quick.textContent = 'Added ✓';
      await updateCartCount();
      setTimeout(() => { quick.textContent = originalText; }, 1800);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error('[undine] quick-add error', err);
      quick.textContent = 'Try again';
      setTimeout(() => { quick.textContent = originalText; }, 1800);
    }
  });

  // ─── PDP gallery thumbnail switching ───────────────────────────────
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb) return;
    e.preventDefault();
    const hero = document.getElementById('pdp-hero-img');
    if (!hero) return;
    const fullSrc = thumb.dataset.fullSrc;
    const fullSrcset = thumb.dataset.fullSrcset;
    if (!fullSrc) return;
    if (fullSrcset) hero.setAttribute('srcset', fullSrcset);
    hero.setAttribute('src', fullSrc);
    document.querySelectorAll('.pdp-thumb').forEach((t) => {
      t.classList.toggle('is-active', t === thumb);
      t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
    });
  });

  // ─── PDP quantity stepper ──────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.pdp-qty-btn');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    const dir = btn.dataset.qty;
    const cur = parseInt(input.value, 10) || 1;
    const next = dir === 'up' ? cur + 1 : Math.max(1, cur - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ─── Variant switching on PDP ───────────────────────────────────────
  // When the user picks a different option value, update the hidden
  // `id` input so the form submits the right variant.
  const pdpForm = document.getElementById('product-form');
  if (pdpForm) {
    pdpForm.addEventListener('change', (e) => {
      if (!e.target.matches('input[type="radio"][name^="options["]')) return;
      // Collect all selected option values.
      const selected = {};
      pdpForm.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
        const m = r.name.match(/options\[(.+)\]/);
        if (m) selected[m[1]] = r.value;
      });
      // Ask Shopify for the matching variant.
      const handle = window.location.pathname.split('/').pop();
      fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((p) => {
          const match = p.variants.find((v) =>
            v.options.every((opt, i) => selected[p.options[i]] === opt)
          );
          if (match) {
            const idInput = pdpForm.querySelector('input[name="id"]');
            if (idInput) idInput.value = match.id;
            const btn = pdpForm.querySelector('.pdp-add');
            if (btn) {
              if (match.available) {
                btn.disabled = false;
                btn.innerHTML = `Add to bag &mdash; ${formatMoney(match.price)}`;
              } else {
                btn.disabled = true;
                btn.textContent = 'Sold out';
              }
            }
          }
        })
        .catch(() => { /* non-fatal */ });
    });
  }

  // tiny money-format helper (USD only, matches Shopify default)
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── PLP filter dropdowns: single-open + outside-click + esc ─────
  // Native <details> doesn't auto-close siblings. Without this, clicking
  // a second filter chip leaves the first hovering and they overlap.
  (function () {
    const filters = document.querySelectorAll('.plp-filters .plp-filter');
    if (!filters.length) return;
    filters.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;
        filters.forEach((other) => { if (other !== d) other.open = false; });
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.plp-filter')) {
        filters.forEach((d) => { d.open = false; });
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      filters.forEach((d) => { d.open = false; });
    });
  })();

  // ─── PLP infinite scroll ──────────────────────────────────────────
  // Hide the next/prev pager and fetch the next page via Shopify's
  // Section Rendering API (?section_id=X). When the sentinel scrolls
  // into view, we fetch /collections/X?page=N&section_id=plp, parse
  // the response, append the new product cards, and bump the page.
  // Falls back to the visible pagination links if JS is disabled or
  // the fetch fails.
  (function () {
    const grid = document.querySelector('.plp .grid');
    const paginate = document.querySelector('.plp-paginate');
    if (!grid || !paginate) return;
    const nextLink = paginate.querySelector('a[rel="next"]');
    if (!nextLink) return;
    // Section id: the closest <section data-shopify-section-id="..."> wrapper added by Shopify automatically.
    const sectionEl = grid.closest('[id^="shopify-section-"]');
    const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    if (!sectionId) return;

    let nextUrl = nextLink.getAttribute('href');
    let loading = false;

    // Hide the visible paginator (kept as no-JS fallback).
    paginate.classList.add('plp-paginate--js');

    const sentinel = document.createElement('div');
    sentinel.className = 'plp-infinite-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    paginate.before(sentinel);

    const status = document.createElement('div');
    status.className = 'plp-infinite-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    paginate.before(status);

    const loadNext = async () => {
      if (loading || !nextUrl) return;
      loading = true;
      status.textContent = 'Loading more pieces…';
      try {
        const u = new URL(nextUrl, window.location.origin);
        u.searchParams.set('section_id', sectionId);
        const res = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('http ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = doc.querySelectorAll('.plp .grid > .product-card');
        if (newCards.length === 0) {
          nextUrl = null;
          status.textContent = '';
          sentinel.remove();
          return;
        }
        newCards.forEach((c) => grid.appendChild(c));
        // Update history so back-button returns to the right page.
        const visibleUrl = new URL(nextUrl, window.location.origin);
        history.replaceState({}, '', visibleUrl.toString());
        // Find the next page link inside the response for the next iteration.
        const nextNext = doc.querySelector('.plp-paginate a[rel="next"]');
        nextUrl = nextNext ? nextNext.getAttribute('href') : null;
        status.textContent = '';
        if (!nextUrl) sentinel.remove();
      } catch (err) {
        console.error('[undine] infinite-scroll error', err);
        // Fall back: surface the original paginator so the user isn't stranded.
        paginate.classList.remove('plp-paginate--js');
        status.textContent = '';
        sentinel.remove();
      } finally {
        loading = false;
      }
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadNext();
      });
    }, { rootMargin: '600px 0px' });
    io.observe(sentinel);
  })();
})();
